// extracted by mini-css-extract-plugin
module.exports = {"main-tab-list":"main-tab-list__1c9Rq","main-tab":"main-tab__3mpxH","selected":"selected__1h8vl","icon-wrapper":"icon-wrapper__Ab4R8","icon":"icon__3MOWD","title":"title__AaGYg"};